// extracted by mini-css-extract-plugin
export default {"placeholder":"PermissionHOC_placeholder__PuKeA","description":"PermissionHOC_description__s25oB"};